<template>
  <li v-if="state !== 'unsupported'" class="w-100 m-push-item">
    <a :class="{ 'is-busy': busy }" @click="onClick">
      <span class="sidebar-mini"
        ><i class="material-icons">{{
          state === "on" ? "notifications_active" : "notifications_off"
        }}</i></span
      >
      <span class="sidebar-normal">{{
        state === "on" ? $t("mobile.pushOn") : $t("mobile.pushOff")
      }}</span>
    </a>
    <p v-if="hint" class="m-push-item__hint">{{ hint }}</p>
  </li>
</template>

<script>
import { getPushState, enablePush, disablePush, PUSH_STATE_EVENT } from "@/utils/pushNotifications";

/**
 * «Activar notificaciones» en el menú del usuario, solo en el teléfono (lo monta UserMenu con
 * isMobileLayout): avisos de los emails que recibe el usuario y de las respuestas del Agente IA.
 */
export default {
  name: "MobilePushMenuItem",
  data() {
    return { state: "unsupported", busy: false, hint: "" };
  },
  async mounted() {
    window.addEventListener(PUSH_STATE_EVENT, this.onStateChanged);
    this.state = await getPushState();
  },
  beforeDestroy() {
    window.removeEventListener(PUSH_STATE_EVENT, this.onStateChanged);
  },
  methods: {
    /** Activadas o apagadas desde otro lado (tarjeta, menú, chat). */
    onStateChanged(e) {
      if (e.detail && (this.state === "on" || this.state === "off")) this.state = e.detail.state;
    },
    async onClick() {
      if (this.busy) return;
      this.hint = "";
      if (this.state === "needs-install") {
        this.hint = this.$t("mobile.pushNeedsInstall");
        return;
      }
      this.busy = true;
      try {
        if (this.state === "on") {
          await disablePush();
          this.state = "off";
          return;
        }
        const result = await enablePush();
        if (result === "denied") this.hint = this.$t("mobile.pushDenied");
        else if (result === "unavailable") this.hint = this.$t("ai.agentChatNotifyUnavailable");
        else {
          this.state = "on";
          this.hint = this.$t("mobile.pushEnabled");
        }
      } catch (e) {
        this.hint = (e.response && e.response.data && e.response.data.error) || e.message;
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped>
.m-push-item a {
  cursor: pointer;
}
.m-push-item a.is-busy {
  opacity: 0.6;
}
.m-push-item__hint {
  margin: 0.25rem 15px 0.5rem;
  font-size: 0.8rem;
  line-height: 1.35;
  white-space: normal;
  opacity: 0.85;
}
</style>
